import * as React from "react";

function SvgNounSalary(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <g fill="#039be5" fillRule="evenodd">
        <path
          data-name="Path 43942"
          d="M5.572 7.456a3.715 3.715 0 103.715 3.715 3.716 3.716 0 00-3.715-3.715zm0 1.858a1.857 1.857 0 11-1.857 1.857 1.857 1.857 0 011.857-1.857z"
        />
        <path
          data-name="Path 43943"
          d="M14.094 5.863a2.786 2.786 0 102.786 2.786 2.787 2.787 0 00-2.786-2.786zm0 1.857a.929.929 0 11-.929.929.929.929 0 01.929-.929z"
        />
        <path
          data-name="Path 43944"
          d="M11.143 21.214v-.572a5 5 0 00-5-5H4.999a5 5 0 00-5 5v.575a2.787 2.787 0 002.786 2.786h5.572a2.787 2.787 0 002.786-2.786zm-1.857-.576v.576a.928.928 0 01-.929.929H2.785a.928.928 0 01-.929-.929v-.572a3.14 3.14 0 013.139-3.14h1.152a3.139 3.139 0 013.139 3.139z"
        />
        <path
          data-name="Path 43945"
          d="M4.499 5.844V2.785a.929.929 0 01.929-.929h15.786a.929.929 0 01.929.929v13a.93.93 0 01-.929.929H10.071a.928.928 0 100 1.856h11.143A2.785 2.785 0 0024 15.784v-13A2.785 2.785 0 0021.214.001H5.428a2.785 2.785 0 00-2.786 2.786v3.059a.929.929 0 001.857 0z"
        />
      </g>
    </svg>
  );
}

export default SvgNounSalary;
